import { render, staticRenderFns } from "./cAccordianRouterLink.vue?vue&type=template&id=b5bbf982&"
import script from "./cAccordianRouterLink.vue?vue&type=script&lang=js&"
export * from "./cAccordianRouterLink.vue?vue&type=script&lang=js&"
import style0 from "./cAccordianRouterLink.vue?vue&type=style&index=0&id=b5bbf982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports